<template>
    <v-row class="white-card px-3">
        <v-col cols="12">
            <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
        </v-col>
        <v-col cols="12" class="headline-heavy text-center">
            Tu perfil médico
        </v-col>
        <v-col cols="12" md="6">
            <kimsa-text-field
                label="Peso"
                @change="weight = $event"
                :value="weight"
                type="number"
                suffix="kg"
                outlined dense
            />
        </v-col>
        <v-col cols="12" md="6">
            <kimsa-text-field
                label="Estatura"
                @change="height = $event"
                :value="height"
                type="number"
                suffix="cm"
                outlined dense
            />
        </v-col>
        <v-col cols="12">
            <div class="subheader-heavy">
                Antecedentes personales
            </div>
            <div class="subtitle-profile mt-2 mb-5">
                Marca la casilla si alguna vez te han diagnosticado alguna de las siguientes enfermedades o factores de riesgo
            </div>
            <kimsa-button-selector
                :items="personalOptions"
                :value="personal"
                @change="personal = $event"
                item-value="value"
                no-object
            />
        </v-col>
        <v-col cols="12">
            <div class="subheader-heavy">
                Antecedentes familiares
            </div>
            <div class="subtitle-profile mt-2 mb-5">
                Marca la casilla si a algún miembro de tu familia le han diagnosticado alguna de las siguientes enfermedades (papás, abuelos o hermanos)
            </div>
            <kimsa-button-selector
                :items="familiarOptions"
                :value="familiar"
                @change="familiar = $event"
                item-value="value"
                no-object
            />
        </v-col>
        <v-col cols="12" class="text-center my-5">
            <v-btn color="secondary" x-large depressed class="normal-btn" :disabled="disabled" :loading="loading"
                   @click="onContinue">
                Continuar
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import KimsaButtonSelector from "@/components/common/inputs/KimsaButtonSelector";
import {options} from "@/utils/Options";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import httpService from "@/services/httpService";

export default {
    name: "ClientProfileSelector",
    components: {KimsaTextField, KimsaButtonSelector},
    data() {
        return {
            loading: false,
            weight: 0,
            height: 0,
            imc: 0,

            personal: [],
            familiar: [],

            familiarOptions: [],
            personalOptions: [],
        }
    },
    async mounted() {
        const vm = this
        await vm.loadRecords()
        vm.setDefaults()
    },
    computed: {
        disabled(vm = this) {
            return !vm.weight || !vm.height
        }
    },
    methods: {
        async loadRecords() {
            const vm = this
            let response = await httpService.get('records')
            // console.log('response loadRecords', response)
            vm.personalOptions = response.data.personal
            vm.familiarOptions = response.data.familiar
        },
        setDefaults() {
            const vm = this
            vm.height = vm.currentUser?.height || 0
            vm.weight = vm.currentUser?.weight || 0
            vm.familiar = vm.getIdsFromArray(vm.currentUser.records, 'type', 'familiar')
            vm.personal = vm.getIdsFromArray(vm.currentUser.records, 'type', 'personal')
        },
        calculateIMC() {
            const vm = this
            if (!vm.weight || !vm.height || vm.weight < 10 || vm.height < 50) return
            vm.imc = Math.round(Number(vm.weight) / (Math.pow(Number(vm.height / 100), 2)) * 10) / 10;
        },
        checkIMC() {
            const vm = this
            if(vm.imc < 25) return
            let age = vm.$moment().diff(vm.$moment(vm.currentUser.birth_date), 'years')
            const OVERWEIGHT = 6
            const OBESITY = 7
            if(age >= 20 && age <= 59) {
                if(vm.imc >= 25 && vm.imc <= 29.9) {
                    vm.personal = vm.personal.filter(p => p !== OVERWEIGHT)
                    vm.personal.push(OVERWEIGHT)
                }
                if(vm.imc >= 30) {
                    vm.personal = vm.personal.filter(p => p !== OBESITY)
                    vm.personal.push(OBESITY)
                }
            }
            if(age >= 60) {
                if(vm.imc >= 27 && vm.imc <= 31.9) {
                    vm.personal = vm.personal.filter(p => p !== OVERWEIGHT)
                    vm.personal.push(OVERWEIGHT)
                }
                if(vm.imc >= 32) {
                    vm.personal = vm.personal.filter(p => p !== OBESITY)
                    vm.personal.push(OBESITY)
                }
            }
        },
        async onContinue() {
            const vm = this
            vm.loading = true

            let payload = {
                height: vm.height,
                weight: vm.weight,
                imc: vm.imc + '',
                records: [...vm.personal, ...vm.familiar],
            }

            let response = await httpService.put(`users/${vm.currentUser.id}/edit`, payload)
            console.log('response onContinue', response)

            vm.loading = false
            vm.$emit('success')
        },
    },
    watch: {
        height() {
            this.calculateIMC()
        },
        weight() {
            this.calculateIMC()
        },
        imc() {
            this.checkIMC()
        },
    }
}
</script>

<style scoped>

.subtitle-profile {
    font-size: 14px;
    line-height: 16px;
    color: #939BB3;
}

</style>